/******************************************************************************
 *** BgtSpcExpndListViewDialog ** 특별회계기금 여입/자료제출 결의서 작성 * 연계 지출결의서 목록 모달
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";

interface Props {
    ognzCd             : string;   // 조직코드(지부)
    systemCode         : string;   // 시스템코드
    expndRsdocSeCd     : string;   // 결의서 구분(여입[03], 자료제출[04])
    setLinkDocFindModal: Function; // 모달 오픈
    setLnkgSpcAcntgExpndDocId: Function; // 연결 지출결의서 문서 ID
    setLnkgExpndRsdocNo: Function; // 연결 지출결의서 문서 ID
    setImplDt          : Function; // 행위년월일
    setBgtSbjct1stCd   : Function; // 관
    setBgtSbjct2stCd   : Function; // 항
    setBgtSbjct3stCd   : Function; // 목
    setAvailAmount     : Function; // 집행가능금액
    setAbstrCn         : Function; // 적요
}
const BgtSpcExpndListViewDialog = ( {ognzCd, systemCode, expndRsdocSeCd, setLinkDocFindModal, setLnkgExpndRsdocNo,
                                     setLnkgSpcAcntgExpndDocId, setImplDt, setBgtSbjct1stCd, setBgtSbjct2stCd, setBgtSbjct3stCd, setAvailAmount, setAbstrCn
                                    }: Props ) => {
    const [expenseDataArr, setExpenseDataArr ] = React.useState<any[]>([]);  // 지출결의서 목록
    const [searchKywd    , setSearchKywd    ] = React.useState<string>(""); // 검색 조건(적요)
    const [acntgYear     , setAcntgYear     ] = React.useState<string>(Util.getNowAcntgYear()); // 회계연도

    const expenseFldInfs: fldInfsProps[] = [
        { type: "date" , fldNm: "implDt"            , width:  90, headAlign: "center", dataAlign: "center", label: "행위년월일" },
        { type: "text" , fldNm: "expndRsdocSeNm"    , width:  70, headAlign: "center", dataAlign: "center", label: "구분"       },
        { type: "text" , fldNm: "bgtSbjct1stNm"     , width:  70, headAlign: "center", dataAlign: "center", label: "관"         },
        { type: "text" , fldNm: "bgtSbjct2stNm"     , width:  80, headAlign: "center", dataAlign: "center", label: "항"         },
        { type: "text" , fldNm: "bgtSbjct3stNm"     , width:  90, headAlign: "center", dataAlign: "center", label: "목"         },
        { type: "text" , fldNm: "abstrCn"           , width: 100, headAlign: "center", dataAlign: "center", label: "적요"       },
        { type: "comma", fldNm: "implAmt"           , width:  90, headAlign: "center", dataAlign: "right" , label: "금액"       },
        { type: "text" , fldNm: "expndRsdocNo"      , width: 110, headAlign: "center", dataAlign: "center", label: "문서번호"   },
    ];

    // 특별회계기금 지출결의서 결재완료 목록 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/spc/cmptn/select-bgt-spc-cmptn-expnd-list.do",  // 결재완료 지출결의서 목록
            methodType: "post",
            paramType: "json",
            paramData: {
                orgCd             : ognzCd        , // 조직코드
                acntgYear         : acntgYear     , // 회계연도
                spcAcntgSeCd      : systemCode    , // 시스템ID
                prcsExpndRsdocSeCd: expndRsdocSeCd  // 연결문서 찾기 구분코드(여입결의서[03], 자료제출[04])
            },
            onSuccessFn: (res: any) => {
                setExpenseDataArr(res.result.list);
                AppContext.hideSpinner();
            },
        });
    }, [ognzCd, acntgYear, systemCode, expndRsdocSeCd]);

    return (
        <div className="w100p jcC pt10 w800">
            <div className="bd1d9d9d9 bdrd5 bgcWhite p15">
                <div className="dpFlx aiC jcSb mb10 h44 w100p">
                    <div className="dpFlx">
                        <span className="fm-b fs16 fc007bff ls1 fw700">지출 결의서</span>
                    </div>
                    
                    <div className="dpFlx aiC mlA">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회계연도</span>
                        <SelectBox value={acntgYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택"
                            onChangeFunc={(data: string) => setAcntgYear(data)}
                        />
                    </div>
                    
                    {/* 적요 */}
                    <div className="dpFlx aiC ml20">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">적요</span>
                        <TextBox value={searchKywd}
                            width={200} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="검색어 입력"
                            onChangeFunc={(text: string) => setSearchKywd(text)}
                        />
                    </div>
                </div>

                {/* 그리드 */}
                <GridTable
                    tableInfo={{
                        tableHeadVsb: true,
                        styleType: AdminGridStyle,
                        fldInfs: expenseFldInfs,
                        ordFld: { name: "implDt", direction: "desc" },
                        dataArr: Util.filterFieldData(expenseDataArr, expenseFldInfs, "abstrCn", searchKywd),
                        maxRowNums: [10, 30, 50],
                        theadTrHeight: 40,
                        tbodyTrHeight: 35,
                        bodyHeight: 350,
                        remainArea: true,
                        paginateClass: "pt10",
                        paginateStyle: {
                            buttonOnColor: AppContext.boardThemeColor,
                            buttonWidth: 22,
                            buttonHeight: 24,
                            buttonMarginLeft: 1,
                            buttonMarginRight: 1,
                            fontSize: 13,
                            color: "#666666",
                            letterSpacing: -0.8,
                            fontFamily: "Pretendard-Regular",
                            borderRadius: 3,
                        },
                        footerVsb: true,
                        rowClickFunc: (item: any) => {  // row click
                            setLnkgSpcAcntgExpndDocId(item.spcAcntgExpndDocId); // 연결 지출결의서 문서 ID
                            setLnkgExpndRsdocNo(item.expndRsdocNo); // 연결 지출결의서 문서 번호
                            if (expndRsdocSeCd === "04") { // 자료 제출 결의서
                                setImplDt (item.implDt ); // 행위년월일
                                setAbstrCn(item.abstrCn); // 적요
                            }
                            setAvailAmount  (item.implAmt      ); // 집행가능금액(= 이전 결의서의 집행금액)
                            setBgtSbjct1stCd(item.bgtSbjct1stCd); // 관
                            setBgtSbjct2stCd(item.bgtSbjct2stCd); // 항
                            setBgtSbjct3stCd(item.bgtSbjct3stCd); // 목

                            setLinkDocFindModal(false);
                        },
                    }}
                />
            </div>

            {/* 닫기 버튼 */}
            <div className="dpFlx jcC pt20 pb20">
                <Button buttonName="닫기"
                    width={110} height={42}
                    fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                    variant="styCloseBtn" borderRadius={5}
                    buttonClass="dpFlx aiC jcC op80-hover"
                    onClickFunc={() => setLinkDocFindModal(false)}
                />
            </div>
        </div>
    )
}


export default BgtSpcExpndListViewDialog;